export enum PromocodeErrorCode {
  ALREADY_USED = 'promocode_already_used',
  INACTIVE = 'promocode_inactive',
  VALIDATION_FAILED = 'promocode_validation_failed',
}

export type PromocodeErrorResponse = {
  code: PromocodeErrorCode;
  message: string;
};
